(function(angular){
	'use strict';

	angular
		.module('coreModule')
		.directive('tableRowHover', [
			'$compile',
			'$timeout',
			tableRowHoverFunction
		]);

	function tableRowHoverFunction($compile, $timeout) {
		return {
			restrict: 'A',
			link: function($scope, $element, $attrs) {
				var alias;
				var offsetTop;
				var rowHeight;

				$element.on('mouseenter', function() {
					offsetTop = parseInt($element[0].offsetTop);
					rowHeight = parseInt($element[0].offsetHeight);
					alias = $compile('<span class="selectable-tr__alias" style="top:' + offsetTop + 'px; height:' + (rowHeight + 1) + 'px;"></span>')($scope);
					$element[0].firstElementChild.appendChild(alias[0]);
				});

				$element.on('mousedown', function() {
					alias.addClass('active');
				});

				$element.on('mouseleave', function() {
					alias.remove();
				});
			}
		};
	}
})(window.angular);